import { useRecoilState } from 'recoil'
import styled from '@emotion/styled'
import { IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { Close } from '@emotion-icons/material/Close'
import { Search } from '@emotion-icons/fa-solid/Search'
import { Colors, Shapes } from 'src/components/theme'

import * as atoms from 'src/atoms/zone'
import { FC } from 'react'

const Wrapper = styled.div`
  display: flex;
  gap: ${Shapes.spacing[2]}px;
  align-items: center;
`
const StyledTextField = styled(TextField)`
  background-color: ${Colors.bgWhite};
`
type ZoningUsesFilterContentProps = {
  value: string
  onChange: (value: string) => void
}
export const ZoningUsesFilterContent: FC<ZoningUsesFilterContentProps> = ({ onChange, value }) => {
  const onSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value)
  }
  const onClearSearch = () => {
    onChange('')
  }
  return (
    <Wrapper>
      <Typography variant="text1">Search for a use:</Typography>
      <StyledTextField
        size="small"
        placeholder="Search"
        value={value}
        onChange={onSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search size={14} color={Colors.textLight} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <IconButton size="small" aria-label="clear search" onClick={onClearSearch} edge="end">
                <Close size={14} color={Colors.textLight} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </Wrapper>
  )
}

export const ZoningUsesFilter = () => {
  const [search, setSearch] = useRecoilState(atoms.zoningUsesSearch)

  return <ZoningUsesFilterContent value={search} onChange={setSearch} />
}
